module.exports = __webpack_public_path__ + "static/media/skincare-prod2.42d53165.png";